"use client";
import WorldMap from "@/components/ui/world-map";
import currentCities from "@/lib/currentCities";


export function MapOfPoland() {
    return (
        <div className="pt-40 dark:bg-black bg-white w-full">
            <div className="max-w-7xl mx-auto text-center">
                <p className="font-semibold text-xl md:text-4xl dark:text-white text-black">
                    Cała Polska
                </p>
                <p className="text-sm md:text-lg text-neutral-500 max-w-2xl mx-auto py-4">
                    Możesz znaleźć nas w wielu miastach w Polsce. Załóż własną już dziś.
                </p>
            </div>
            <WorldMap
                dots={currentCities}
            />
        </div>)
}